import Vue from "vue";
import { GetCasesUrl } from "@/utils/apiUrls";
import sponsorship from "./sponsorship";
import { statuses } from "@/data/statuses";

export default {
  namespaced: true,

  modules: {
    sponsorship,
  },

  state: {
    usercaseList: [],
  },

  getters: {
    currentUsercase: (state, getters, rootState) => {
      const case_id = parseInt(rootState.route?.params?.case_id);
      return state.usercaseList.find(({ ID }) => ID === case_id) ?? null;
    },

    ID: (state, getters) => {
      return getters.currentUsercase?.ID ?? 0;
    },

    statusIndex: (state, getters) => {
      const status = getters.currentUsercase?.status;
      return statuses.map(({ alias }) => alias).indexOf(status);
    },

    isPaid: (state, getters) => {
      return getters.currentUsercase?.payment_status ?? false;
    },

    isNonEditable: (state, getters) => {
      const index = getters.statusIndex;
      if (index <= 4) return false;
      if (index === 7) return false;
      return true;
    },
  },

  mutations: {
    updateUsercaseList: (state, payload) => {
      state.usercaseList = payload;
    },
  },

  actions: {
    refreshUsercaseList: async ({ commit }) => {
      await Vue.axios
        .get(GetCasesUrl)
        .then((resp) => {
          commit("updateUsercaseList", resp.data);
        })
        .catch(console.error);
    },
  },
};
